export default "__VITE_ASSET__BM$XJpcN__"